import React, { lazy, Suspense } from "react";
export { default as SellPrint } from "./SellContract_Agent/SellPrint";

export { default as RentPrint } from "./RentContract_Agent/RentPrint";

//
const LazyListRentContract = lazy(() =>
  import("./RentContract_Agent/ListRentContract")
);
const LazyEditContractSell = lazy(() =>
  import("./SellContract_Agent/EditContractSell")
);
const LazyEditContractRentList = lazy(() =>
  import("./RentContract_Agent/EditContractRentList")
);
//
const LazySecondaryForm = lazy(() =>
  import("./RentContract_Agent/SecondaryForm")
);
const LazySellSecondaryForm = lazy(() =>
  import("./SellContract_Agent/SellSecondaryForm")
);
const LazyListSellContract = lazy(() =>
  import("./SellContract_Agent/ListSellContract")
);
const LazyListSellContract_Failed = lazy(() =>
  import("./SellContract_Agent/ListSellContract_Failed")
);
const LazyListRentContract_Failed = lazy(() =>
  import("./RentContract_Agent/ListRentContract_Failed")
);

const LazySellMainForm = lazy(() =>
  import("./SellContract_Agent/SellMain_Form")
);
const LazyMainForm = lazy(() => import("./RentContract_Agent/Main_Form"));
const LazyEditInvoce = lazy(() => import("./SellContract_Agent/EditInvoce"));
const LazyEditRentInvoice = lazy(() =>
  import("./RentContract_Agent/EditRentInvoice")
);
const LazyListcomericalContract = lazy(() =>
  import("./CommericalContract/ListcomericalContract")
);
const LazyPrintCommerical = lazy(() =>
  import("./CommericalContract/PrintCommerical")
);
const LazyListTakeMoneyOnSellContract = lazy(() =>
  import("./SellContract_Agent/ListTakeMoneyOnSellContract")
);
const LazyTakeMoneyOnSellContract = lazy(() =>
  import("./SellContract_Agent/TakeMoneyOnSellContract")
);
const LazyListParadanOnSellContract = lazy(() =>
  import("./SellContract_Agent/ListParadanOnSellContract")
);
const LazyParadanOnSellContract = lazy(() =>
  import("./SellContract_Agent/ParadanOnSellContract")
);
// 
const LazyListParadanOnRentContract = lazy(() =>
  import("./RentContract_Agent/ListParadanOnRentContract")
);
const LazyListTakeMoneyOnRentContract = lazy(() =>
  import("./RentContract_Agent/ListTakeMoneyOnRentContract")
);
export const ListParadanOnRentContract = () => (
  <Suspense fallback="loading...">
    <LazyListParadanOnRentContract />
  </Suspense>
);
export const ListTakeMoneyOnRentContract = () => (
  <Suspense fallback="loading...">
    <LazyListTakeMoneyOnRentContract />
  </Suspense>
);
// 
export const ListParadanOnSellContract = () => (
  <Suspense fallback="loading...">
    <LazyListParadanOnSellContract />
  </Suspense>
);
export const ParadanOnSellContract = () => (
  <Suspense fallback="loading...">
    <LazyParadanOnSellContract />
  </Suspense>
);
export const ListTakeMoneyOnSellContract = () => (
  <Suspense fallback="loading...">
    <LazyListTakeMoneyOnSellContract />
  </Suspense>
);
export const TakeMoneyOnSellContract = () => (
  <Suspense fallback="loading...">
    <LazyTakeMoneyOnSellContract />
  </Suspense>
);
export const PrintCommerical = () => (
  <Suspense fallback="loading...">
    <LazyPrintCommerical />
  </Suspense>
);
export const ListcomericalContract = () => (
  <Suspense fallback="loading...">
    <LazyListcomericalContract />
  </Suspense>
);
export const ListRentContract = () => (
  <Suspense fallback="loading...">
    <LazyListRentContract />
  </Suspense>
);
export const ListSellContract_Failed = () => (
  <Suspense fallback="loading...">
    <LazyListSellContract_Failed />
  </Suspense>
);
export const ListRentContract_Failed = () => (
  <Suspense fallback="loading...">
    <LazyListRentContract_Failed />
  </Suspense>
);
export const SellMain_Form = () => (
  <Suspense fallback="loading...">
    <LazySellMainForm />
  </Suspense>
);
export const Main_Form = () => (
  <Suspense fallback="loading...">
    <LazyMainForm />
  </Suspense>
);

export const EditInvoce = () => (
  <Suspense fallback="loading...">
    <LazyEditInvoce />
  </Suspense>
);
export const EditRentInvoice = () => (
  <Suspense fallback="loading...">
    <LazyEditRentInvoice />
  </Suspense>
);

export const SecondaryForm = () => (
  <Suspense fallback="loading...">
    <LazySecondaryForm />
  </Suspense>
);
export const SellSecondaryForm = () => (
  <Suspense fallback="loading...">
    <LazySellSecondaryForm />
  </Suspense>
);
export const ListSellContract = () => (
  <Suspense fallback="loading...">
    <LazyListSellContract />
  </Suspense>
);

export const EditContractSell = () => (
  <Suspense fallback="loading...">
    <LazyEditContractSell />
  </Suspense>
);
export const EditContractRentList = () => (
  <Suspense fallback="loading...">
    <LazyEditContractRentList />
  </Suspense>
);
